export enum MenuActionBehavior {
    Emit = 'emit',
    Route = 'route'
}
